import React from 'react';
import styles from 'components/layout_and_quote_builder/_style.module.scss';

const LoadingOverlay = ({ message }) => {
  const displayMessage = message || 'Loading';

  return (
    <div className={styles.progressOverlay}>
      <div className={styles.progressCard}>
        <div className={styles.progressTitle}>
          {displayMessage}
        </div>

        <div className={styles.loadingSpinnerContainer}>
          <img
            src="https://d2atdwxjx7uc4i.cloudfront.net/images/bx_loader.gif"
            width="40px"
            alt="Loading"
          />
        </div>

        <div className={styles.loadingHint}>
          {t('quote_builder.loading_hint')}
        </div>
      </div>
    </div>
  );
};

export default LoadingOverlay;
